import { render, staticRenderFns } from "./StockMFI.vue?vue&type=template&id=c0939ba2&scoped=true"
import script from "./StockMFI.vue?vue&type=script&lang=js"
export * from "./StockMFI.vue?vue&type=script&lang=js"
import style0 from "./StockMFI.vue?vue&type=style&index=0&id=c0939ba2&prod&scoped=true&lang=css"
import style1 from "./StockMFI.vue?vue&type=style&index=1&id=c0939ba2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0939ba2",
  null
  
)

export default component.exports